// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inputfile{width:0.1px;height:0.1px;opacity:0;overflow:hidden;position:absolute;z-index:-1}.inputfile+label{display:flex;justify-content:center;align-items:center;width:100px;height:100px}.inputfile+label{cursor:pointer}.inputfile+label *{pointer-events:none}.modalui{display:flex;flex-wrap:wrap;justify-content:left}.ant-card-body{display:none}\n", ""]);
// Exports
module.exports = exports;
